export default __webpack_public_path__ + "static/media/generate-szag-icon.eab2972d.svg";